  import config from "./config";
  const baseUrl = config.API_BASE_URL;

  export const URL = {
    ADD_CITY: `${baseUrl}/blocked/city_add`,
    ADD_PINCODE: `${baseUrl}/blocked/pincode_add`,

    ASSIGN_BULK_PRIVILEGE: `${baseUrl}/login/assign_bulk_privilege`,
    CALCULATE_FOIR: `${baseUrl}/foir/calculate`,
    

    BLOCKED_CITY: `${baseUrl}/blocked/city`,
    BLOCKED_PINCODE: `${baseUrl}/blocked/pincode`,
    BLOCKED_STATE: `${baseUrl}/blocked/state`,
    CASE_CLOSE_LOAN: `${baseUrl}/credit/case_close_loan`,
    CUSTOMER_DETAILS: `${baseUrl}/customer/details`,
    CUSTOMER_HEADER_DETAILS: `${baseUrl}/customer/header`,

    DASHBOARD_LEAD_LIST: `${baseUrl}/dashboard/lead_list`,
    DASHBOARD_CARD: `${baseUrl}/dashboard/card_counts`,

    ADD_COMMENTS: `${baseUrl}/comment/add`,
    GET_DOCUMENTS: `${baseUrl}/documents/get_all`,
    GET_FOIR_DATA: `${baseUrl}/credit/get_foir_data`,
    GET_PRIVILEGE_LIST: `${baseUrl}/privilege/get_all`,
    GET_USER_LIST: `${baseUrl}/users/login`,

    LEAD_LIST: `${baseUrl}/leads/lead_list_details`,
    LOGIN: `${baseUrl}/login/loginUser`,
    LSP_LIST: `${baseUrl}/lsp/list`,
    LSP_LIST_PASSWORD_UPDATE: `${baseUrl}/lsp/update_password`,
    LSP_LIST_ADD: `${baseUrl}/lsp/add`,
    LSP_LIST_FINTECHID :`${baseUrl}/lsp/getByFintechId`,
    LSP_UPDATE: `${baseUrl}/lsp/update_status`,

    LSP_LIST_UPDATE :`${baseUrl}/lsp/update`,
    LSP_STATE_LIST : `${baseUrl}/lsp/stateList`,


    PAN_DETAILS: `${baseUrl}/credit/pan_validation`,
    PAN_VALIDATE_THIRD_PARTY: `${baseUrl}/credit/pan_details`, 
    PENNY_DROP_STATUS: `${baseUrl}/credit/penny_status`,
    PENNY_DROP_COMMENT: `${baseUrl}/credit/process_penny`,
    PENNY_IS_DEFAULT: `${baseUrl}/credit/set_isDefault`,
    BUREAU_FETCH: `${baseUrl}/credit/fetchBureau`,
    BUREAU_REPORTS: `${baseUrl}/credit/bureau_details`,
    BUREAU_REPORTSVIEW: `${baseUrl}/templates/credit_report_html`,
    BANKING_DATA: `${baseUrl}/banking/accounts`,
    BANKING_ACCOUNTS_PDF: `${baseUrl}/banking/accountsPdf`,
    GET_FOIR_DATA:`${baseUrl}/foir/foirData`,
    FOIR_CALCULATE:`${baseUrl}/foir/calculate`,
    UPDATE_OBLIGATION:`${baseUrl}/foir/updateObligation`,

    PAYMENT_REPAYMENT_LIST: `${baseUrl}/payment-repayment/list`,
    PAYMENT_COLLECTION_TOTAL: `${baseUrl}/payment-repayment/collection-total`,
    PAYMENT_WALLET_HISTORY: `${baseUrl}/payment-wallet/history`,
    PAYMENT_AUDIT_COUNTS: `${baseUrl}/payment-sync/audit/counts`,
    PAYMENT_AUDIT_TRANSACTIONS: `${baseUrl}/payment-sync/audit/transactions`,
    PAYMENT_TRANSACTIONS: `${baseUrl}/payment-sync/transactions`,
    PAYMENT_AGREEMENT_GENERATE: `${baseUrl}/payment-sync/agreement/generate`,
    PAYMENT_DOC_BACKFILL: `${baseUrl}/payment-sync/agreement/backfill`,
    PAYMENT_DOC_BACKFILL_STOP: `${baseUrl}/payment-sync/agreement/backfill/stop`,
    PAYMENT_DOC_BACKFILL_STATUS: `${baseUrl}/payment-sync/agreement/backfill/status`,
    PAYMENT_EMI_BACKFILL: `${baseUrl}/payment-sync/emi/backfill`,
    PAYMENT_EMI_BACKFILL_STOP: `${baseUrl}/payment-sync/emi/backfill/stop`,
    PAYMENT_EMI_BACKFILL_STATUS: `${baseUrl}/payment-sync/emi/backfill/status`,
    PAYMENT_ADDRESS_STATE_IMPORT: `${baseUrl}/payment-sync/address-state/import`,
    PAYMENT_ADDRESS_CREATE_IMPORT: `${baseUrl}/payment-sync/address/create-import`,
    PAYMENT_EXPORT_WITHDRAWALS: `${baseUrl}/payment-sync/export/withdrawals`,
    PAYMENT_EXPORT_LOGINS: `${baseUrl}/payment-sync/export/logins`,
    PAYMENT_EXPORT_BALANCE: `${baseUrl}/payment-sync/export/balance`,
    PAYMENT_EXPORT_REPAYMENT: `${baseUrl}/payment-sync/export/repayment`,
    PAYMENT_EXPORT_COLLECTION: `${baseUrl}/payment-sync/export/collection`,
    PAYMENT_BILLING_RUN: `${baseUrl}/payment-sync/billing/run`,
    PAYMENT_SYNC_RUN: `${baseUrl}/payment-sync/run`,
    PAYMENT_SYNC_STOP: `${baseUrl}/payment-sync/stop`,
    PAYMENT_FEED_IMPORT: `${baseUrl}/payment-sync/import`,
    PAYMENT_AUTO_CONFIG: `${baseUrl}/payment-sync/auto/config`,
    PAYMENT_AUTO_STATUS: `${baseUrl}/payment-sync/auto/status`,
    PAYMENT_SCHEDULER_CONFIG: `${baseUrl}/payment-sync/scheduler/config`,
    PAYMENT_SCHEDULER_STATUS: `${baseUrl}/payment-sync/scheduler/status`,
    PAYMENT_ENHANCE_LIMIT: `${baseUrl}/payment-sync/wallet/enhance-limit`,
    PAYMENT_ENHANCE_HISTORY: `${baseUrl}/payment-sync/wallet/enhance-limit/history`,
    PAYMENT_AMEND_BREACHED_BULK: `${baseUrl}/payment-sync/wallet/amend-breached-bulk`,
    PAYMENT_AMEND_BREACHED_ALL: `${baseUrl}/payment-sync/wallet/amend-breached-all`,
    PAYMENT_AMEND_BREACHED_STATUS: `${baseUrl}/payment-sync/wallet/amend-breached-status`,
    PAYMENT_PAN_POOL_UPLOAD: `${baseUrl}/payment-sync/pan-pool/upload`,
    PINCODE_UPLOAD: `${baseUrl}/pincode/upload`,
    PINCODE_LOOKUP: `${baseUrl}/pincode/lookup`,
    PAYMENT_SETTLE: `${baseUrl}/payment-sync/settle`,
    PAYMENT_SETTLE_ALL: `${baseUrl}/payment-sync/settle-all`,
    CREDIT_SETTLEMENT_UPLOAD: `${baseUrl}/credit-settlement/upload`,
    PAYMENT_RETRY_ENRICHMENT: `${baseUrl}/payment-sync/retry-enrichment`,
    PAYMENT_ENRICHMENT_CANDIDATES: `${baseUrl}/payment-sync/enrichment/candidates`,
    PAYMENT_ENRICHMENT_CANDIDATE: `${baseUrl}/payment-sync/enrichment/candidate`,
    PAYMENT_EXPORT_PAYIN: `${baseUrl}/payment-sync/export/payin`,
    PAYMENT_RETRY_API: `${baseUrl}/payment-sync/retry-api`,
    PERSONAL_LOAN_BULK_UPLOAD: `${baseUrl}/payment-sync/personal-loan/bulk-upload`,
    NBFC_ANALYTICS_SUMMARY: `${baseUrl}/analytics/nbfc-summary`,
    DASHBOARD_ANALYTICS: `${baseUrl}/dashboard/analytics`,

    PAYMENT_HISTORY: `${baseUrl}/payments/payment_history`,
    AMORT_ADJUSTMENT_FIP: `${baseUrl}/payments/adjustments`,
    INSTALLMENT_FIP: `${baseUrl}/payments/installment_fip`,
    INSTALLMENT_PIF: `${baseUrl}/payments/installment_pif`,
    FOIR_DATA: `${baseUrl}/credit/get_foir_data`,
    UPDATE_FOIR_OBLIGATION: `${baseUrl}/credit/update_foir_account_obligation`,
    NAME_MATCH: `${baseUrl}/credit/get_name_match`,
    GET_BUREAU_REPORTS: `${baseUrl}/credit/bureau_details`,
    GET_PAN_VALIDATION: `${baseUrl}/credit/pan_validation`,

    GET_COMMENTS: `${baseUrl}/comment/get`,
    UPDATE_CUSTOMER_STATUS: `${baseUrl}/api/lead/update_customer_status`,
    
    RESTRUCTURE_DETAILS: `${baseUrl}/credit/restructure_details`,
    CREDIT_DETAILS: `${baseUrl}/credit/details`,
    COMBINED_DETAILS: `${baseUrl}/credit/combined`,
    CALCULATE_EMI: `${baseUrl}/credit/calculate_emi`,
    APPROVE_LOAN: `${baseUrl}/credit/approve_loan`,
    DISBURSE_LOAN: `${baseUrl}/credit/disburse_loan`,
    CANCEL_LOAN: `${baseUrl}/credit/cancel_loan`,
    WRITTEN_OFF_LOAN: `${baseUrl}/credit/written_off_loan`,
    RESTRUCTURE_LOAN: `${baseUrl}/credit/restructure_loan`,
    REJECT_LOAN: `${baseUrl}/credit/reject_loan`,
    CLOSE_LOAN: `${baseUrl}/credit/close_loan`,
    NEW_LOAN: `${baseUrl}/credit/new_loan_status`,
    INCOMPLETE_LOAN: `${baseUrl}/credit/mark_loan_incomplete`,
  
    REFERENCE_DETAILS: `${baseUrl}/customer/referenceDetails`,
    REFRESH_SCORE: `${baseUrl}/credit/refresh_score`,

    RERUN_RULE_ENGIEN: `${baseUrl}/Rule/Engine`,
    RULE_ENGIEN: `${baseUrl}/bre_action/list`,
    RULE_UPDATE_STATUS: `${baseUrl}/bre_action/update_status`,

    SET_SUBTITLE: `${baseUrl}/privilege/add_subtitle`,
    SET_TITLE: `${baseUrl}/privilege/add_title`,
    STATUSES: `${baseUrl}/customer/status_list`,

    UPDATE_LEAD_STATUS: `${baseUrl}/api/lead/update_status`,

    UPDATE_BANKING_DETAILS: `${baseUrl}/customer/update_banking_details`,
    UPDATE_CITY: `${baseUrl}/blocked/city_update`,
    UPDATE_CURRENT_ADDRESS: `${baseUrl}/customer/update_address`,
    UPDATE_CUSTOMER_DETAILS: `${baseUrl}/customer/update_details`,
    UPDATE_FOIR: `${baseUrl}/credit/update_foir_account_obligation`,
    UPDATE_NOMINEE_DETAILS: `${baseUrl}/customer/update_nominee`,
    UPDATE_PINCODE: `${baseUrl}/blocked/pincode_update`,
    UPDATE_PROFESSIONAL: `${baseUrl}/customer/update_professional_details`,
    UPDATE_REFERENCE_DETAILS: `${baseUrl}/customer/update_reference`,
    UPDATE_STATE: `${baseUrl}/blocked/state_update`,
    UPDATE_USER_PRIVILEGE: `${baseUrl}/privilege/update_privilege`,

    UPLOAD_DOCUMENT: `${baseUrl}/documents/upload`,
    UPDATE_DOCUMENT_TYPE: `${baseUrl}/documents/update`,
    READ_XML_DOCUMENT : `${baseUrl}/documents/read_xml`,
    

    GET_DOCUMENT_AADHAR: `${baseUrl}/documents/aadhaar_xml`,

    USER_CREATE: `${baseUrl}/login/create`,
    USER_DATA_FILL: `${baseUrl}/login/user`,
    USER_DATA_UPDATE: `${baseUrl}/login/updateUserFields`,
    USER_PRIVILEGE: `${baseUrl}/privilege/get_user_privilege`,
  


    OKYC_SEND:`${baseUrl}/okyc/details`,
    BANKING_SEND:`${baseUrl}/banking/details`,
    ENACH_SEND:`${baseUrl}/enach/details`,
    PaymentLink_SEND:`${baseUrl}/paymentLink/details`,
    OKYC:`${baseUrl}/reporting/okycSearch`,


    BRE_PRODUCT_LIST: `${baseUrl}/bre/product_list`,
    BRE_POLICY_LIST: `${baseUrl}/bre/policy_list`,
    BRE_POLICY_UPDATE: `${baseUrl}/bre/policy_update`,
    BRE_ADD_PRODUCT_CODE: `${baseUrl}/bre/policy_add`,
    BRE_UPDATE_PRODUCT_ACTIVE: `${baseUrl}/bre/product_active`,
    LEGAL_DOCUMENT: `${baseUrl}/legal/documents`,
    LEGAL_CONSENT:`${baseUrl}/legal/consent`,
    AGREEMENT:`${baseUrl}/documents/get_loan_agreement`,
    MANUAL_EMAIL:`${baseUrl}/emails/manual_email`,


    GET_STATES: `${baseUrl}/customer/states`,
    GET_CITIES: `${baseUrl}/customer/cities`,
    EXTERNAL_SMS:`${baseUrl}/otp/send`,
    BRE_POLICY_REORDER:`${baseUrl}/bre/policy_reorder`,
    TEMPLATE_ADD: `${baseUrl}/templates/add`,
    TEMPLATE_LIST: `${baseUrl}/templates/list`,
    TEMPLATE_UPDATE: `${baseUrl}/templates/update_status`,
    TEMPLATE_NAME: `${baseUrl}/templates/names`,

    ENACH_LIST:`${baseUrl}/razorpay/latest_info`,

    ENACH_LIST_NEW:`${baseUrl}/razorpay/latest_info_new`,
    PAYOUT_PROCESS:`${baseUrl}/disbursal/process`,
    PAYOUT_APPROVE: `${baseUrl}/disbursal/approve`,
    PAYMENT_PROCESS: `${baseUrl}/payments/process`,
    PAYMENT_LIST: `${baseUrl}/payments/list`,
    SETTLEMENT: `${baseUrl}/payments/settlement`,
    SETTLEMENT_PAID: `${baseUrl}/payments/paid`,

    PAYOUT_UPDATE_STATUS:`${baseUrl}/disbursal/update_status`,
    PAYOUT_LOAN_STATUSES: `${baseUrl}/disbursal/status_list`,

    PAYMENT_LOANS:`${baseUrl}/payments/loans`,
    PAYMENT_AND_COMMENT:`${baseUrl}/payment_consent/add_payment_and_comment`,
    PRICING_LIST: `${baseUrl}/pricing/list`,
    PRICING_UPDATE: `${baseUrl}/pricing/update`,
    PAYMENT_EXTRA: `${baseUrl}/payment_consent/apply_extra`,
    PAYMENT_ROLLBACK: `${baseUrl}/payment_consent/rollback`,
    REFUND_EXTRA_PAYMENT: `${baseUrl}/refund/extra-payment`,

    FEES_SUMMERY: `${baseUrl}/payments/fee_summary`,
    FORECLOSURE_SUMMARY: `${baseUrl}/payments/foreclosure_summary`,
    PAYOUT_HISTORY: `${baseUrl}/payout/payoutHistory`,
    PAYOUT_STATUS: `${baseUrl}/payout/status`,
    PAYOUT_ORDER: `${baseUrl}/payout/Order`,
    PAYOUT_PAYMENT: `${baseUrl}/payout/Payment`,
    PAYOUT_DISBURSEL: `${baseUrl}/payout/Disbursal`,
    REPORTING_DISBURSAL: `${baseUrl}/reporting/filter`,
    REPORTING_EMI: `${baseUrl}/reporting/emi_status`,
    REPORTING_PAYMENT_SUMMARY: `${baseUrl}/reporting/payment-summary`,
    REPORTING_COLLECTION_SUMMARY: `${baseUrl}/reporting/collection-summary`,
    REPORTING_PORTFOLIO: `${baseUrl}/reporting/portfolio`,
    DASHBOARD_PARTNER_BREAKDOWN: `${baseUrl}/dashboard/partner-breakdown`,
    LOAN_RECO_DISBURSEMENT: `${baseUrl}/reporting/loan-reco/disbursement`,
    LOAN_RECO_UPLOAD_STATEMENT: `${baseUrl}/reporting/loan-reco/upload-statement`,
    LOAN_RECO_STATEMENTS: `${baseUrl}/reporting/loan-reco/statements`,
    RECO_UPLOAD: `${baseUrl}/reporting/reco/upload`,
    RECO_BATCHES: `${baseUrl}/reporting/reco/batches`,
    RECO_BATCH: `${baseUrl}/reporting/reco/batch`,
    RECO_LINE: `${baseUrl}/reporting/reco/line`,
    REPORTING_FIP: `${baseUrl}/reporting/fip`,
    REPORTING_PIF: `${baseUrl}/reporting/pif`,
    REPORTING_FEE: `${baseUrl}/reporting/fee`,
    REPORTING_FEE_PIF: `${baseUrl}/reporting/feesPIF`,
    PAN_REPORT:`${baseUrl}/reporting/panSearch`,
    PENNY_REPORT:`${baseUrl}/reporting/pennySearch`,
    PENNY_REPORT_FILTER:`${baseUrl}/reporting/pennySearchFilter`,
    OKYC_FILTER:`${baseUrl}/reporting/OkycFilter`,
    BUREAU_FILTER:`${baseUrl}/reporting/bureauFilter`,
    BANKING_REPORT:`${baseUrl}/reporting/bankingSearch`,
    BANKING_REPORT_TODAY:`${baseUrl}/reporting/bankingSearchByToday`,


    PAYMENT_LINK_GENERATE:`${baseUrl}/paymentLink/details`,
    
  
    
    OKYC_REPORT:`${baseUrl}/reporting/pennySearch`,
    CIBIL_REPORT:`${baseUrl}/reporting/pennySearch`,
  
    REPORTING_LOAN_SUMMARY: `${baseUrl}/reporting/loan_summary`,
    REPORTING_CUSTOMER_SUMMARY: `${baseUrl}/reporting/customer_summary`,
    REPORTING_ENACH_PRESENTATION: `${baseUrl}/reporting/enash_presentation`,
    //  LOAN_CARD_REPORT: `${baseUrl}/reporting/loan_card`,
    LOAN_CARD_REPORT: `${baseUrl}/reporting/loan_card`,
    LOAN_APPROVAL: `${baseUrl}/approve/view`,
    LOAN_APPROVAL_EDIT : `${baseUrl}/approve/editSalora`,
    LOAN_APPROVAL_LOCK_FOR_LSP : `${baseUrl}/approve/lockForLsp`,
    LSP_VIEW : `${baseUrl}/approve/lspView`,
    REPORTING_PAYOUTS: `${baseUrl}/reporting/payouts`,
    FINTECH_WALLET: `${baseUrl}/wallet/getAllWallets`,
  Loan_Master_Reporting: `${baseUrl}/api/loan-master-excel`,
  //lsp Balance 
  LSP_BALANCE_CALCULATE: `${baseUrl}/lspBalance/calculate`,
  LSP_BALANCE_UPDATE_LIMIT: `${baseUrl}/lspBalance/updateLimit`,
  LSP_BALANCE_EXPORT_EXCEL: `${baseUrl}/lspBalance/exportExcel`,
  LSP_BALANCE_LIST: `${baseUrl}/lspBalance/list`,
  LSP_BALANCE_CREATE_WALLET: `${baseUrl}/lspBalance/create`,
  FINTECH_ID_LSP: `${baseUrl}/fintech/id_Lsp`,
  LOAN_STATEMENT: `${baseUrl}/loan-statement/data`,
  LSP_PROVIDED_JSON: `${baseUrl}/s3/json/by-lead`,
  LSP_PROVIDED_JSON_FILTER: `${baseUrl}/s3/json/by-identifier`,


  OVERDUE_REPORT:`${baseUrl}/overdueReport/emi`,
  OVERDUE_REPORT_EXCEL:`${baseUrl}/overdueReport/export`,
    BUREAU_REPORT_EXPORT: `${baseUrl}/bureauReport/export`,
  BUREAU_REPORT_ALL: `${baseUrl}/bureauReport/all`,
  BANK:`${baseUrl}/reporting/bankingSearch`,


  // PRODUCT SLAB START 

  PRODUCT_SLAB:`${baseUrl}`,



  //SupportHelp button
  SUPPORT_CONTACT: `${baseUrl}/api/support/contact`,
  LSP_NAMES: `${baseUrl}/fintech/lsp-names`,
  LSP_LEAD_LIST: `${baseUrl}/dashboard/lead_list_by_lsp`,
  //SupportHelp button
  SUPPORT_CONTACT: `${baseUrl}/api/support/contact`
  };

  // Standalone SaloraReporting service (merchant-loan reports, :8081). Separate base URL;
  // the same login JWT validates there. Falls back to the main API if not configured.
  const reportingBase = config.REPORTING_BASE_URL || baseUrl;
  export const REPORTING_URL = {
    MERCHANT_LOAN: `${reportingBase}/merchant-report/loan`,
    MERCHANT_DISBURSEMENT: `${reportingBase}/merchant-report/disbursement`,
    MERCHANT_COLLECTION: `${reportingBase}/merchant-report/collection`,
    MERCHANT_OUTSTANDING: `${reportingBase}/merchant-report/outstanding`,
    MERCHANT_CUSTOMER: `${reportingBase}/merchant-report/customer`,
    MERCHANT_EMI_SCHEDULE: `${reportingBase}/merchant-report/emi-schedule`,
    MERCHANT_INCOME: `${reportingBase}/merchant-report/income`,
    MERCHANT_CHARGE: `${reportingBase}/merchant-report/charge`,
    MERCHANT_WAIVER: `${reportingBase}/merchant-report/waiver`,
    MERCHANT_LOAN_STATEMENT: `${reportingBase}/merchant-report/loan-statement`,
    MERCHANT_LOAN_CARD: `${reportingBase}/merchant-report/loan-card`,
  };


